import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Box, Paper, Radio, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Grid } from '@mui/material'
import { Item, SuccessPopUp } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import {
  PartyRechargesReject,
  PartyRechargesListAllRequest,
  updateModal,
  PartyRechargesAccept,
  GetRechargePaymentModesListAll,
  GetPartyRechargeEditRequest,
  updateLoader,
  updateAlertError,
} from '../../../../../store/common/common_action'
import EditIcon from '@mui/icons-material/Edit'
import * as mdt from '../../../../../components/common/modaltypes'
import Datepicker from '../../../../common/datePicker'
import DropDownOA from '../../../../common/dropDownOA'
import moment from 'moment'
import { backGroundColorForStatus, focusElemnt, isEmpty, lineInputNavigation2, removeDuplicatesFromArray } from '../../../../common/helper'
import { branchRechargeFilterCol, partyHistoryCol, partyHistoryColForSTA, PdfFooter } from './constant'
import PartyViewLimitUses from './PartyViewLimitUses'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
import TablePaginationCustom from '../../../../common/TablePagination'
import { GetCargoSettingData, getOwnChildBranches } from '../../../../../store/reports/reports_action'
import { GetRequest, PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { getPartyRechargeListData } from '../../../../../store/Acounting/acounting_action'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import OTPModal from '../../../BrnchUsrMaster/UserRollRights/OTPModal'
import PartyRequestCancelRemark from './PartyRechargeCancelModel'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { STA_COMPANY_ID } from '../../../../../helper/companyIdhardcode'
import { branchRechargeOTP } from '../../../../common/jotaiState/commonStateAtoms'
const PartyRechargeHistory = (props) => {
  const {
    data,
    PartyRechargesListAllRequest,
    PartyRechargesReject,
    PartyRechargesAccept,
    GetRechargePaymentModesListAll,
    getPartyRechargeListData,
    updateAlertError,
    updateModal, GetCargoSettingData
  } = props
  const { common, reports } = data
  const { loginData, showModal, modalType } = common
  const { getCargoSettingData } = reports
  const { intCompanyID, intBranchID } = loginData
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [tableData, setTableData] = useState([])
  const [viewLimit, setViewLimit] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [showTable, setShowTable] = useState(true)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [sourceCityList, setSourceCityList] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [totalNoOfRows, setTotalNoOfRows] = useState(0)
  const [isSuccessPop, setIsSuccessPop] = useState(false)
  const [isSuccessReject, setIsSuccessReject] = useState(false)
  const [msg, setMsg] = useState('')
  const [resPartyCity, setResPartyCity] = useState([])
  const [updatedRes, setUpdatedRes] = useState([])
  const [OtpModal, setOtpModal] = useState(false)
  const [OTP, setOTP] = useState("")
  const [handleAcceptData, setHandleAcceptData] = useState({})
  const [branchID, setBranchID] = useState(null)
  const [type, setType] = useState(0)
  const [textAreaValue, setTextAreaValue] = useState('')
  const [showModel, setShowModel] = useState(false)
  const [reportData, setReportData] = useState([])
  const [searchData, setSearchData] = useState({
    PartyCity: "",
    PartyID: "",
    PayType: "",
    Party: "",
    PaymentMode: "",
    BankName: "",
    ReferenceNo: "",
    transactionDateTime: '',
    depositDate: '',
    CurrentBalance: '',
    RechargeAmount: '',
    ProcessingFees: '',
    AmountPaid: '',
    ClosingBalance: '',
    RaisedBy: '',
    RechargeStatus: '',
    RejectReason: '',
    AcceptOrRejectedBy: '',
    AcceptedOrRejectedDateTime: '',
  })
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID
      }
      GetCargoSettingData(obj)
    }
  }, [loginData])
  useEffect(() => {
    let fiterData = reportData?.filter((val) =>
      (searchData?.PartyCity === "" || (val?.PartyCity && val?.PartyCity?.toLocaleLowerCase().includes(searchData?.PartyCity?.toLocaleLowerCase()))) &&
      (searchData?.PartyID === "" || (val?.PartyID && val?.PartyID?.toString().toLocaleLowerCase().includes(searchData?.PartyID))) &&
      (searchData?.PayType === "" || (val?.PayType && val?.PayType?.toLocaleLowerCase().includes(searchData?.PayType?.toLocaleLowerCase()))) &&
      (searchData?.Party === "" || (val?.Party && val?.Party?.toLocaleLowerCase().includes(searchData?.Party?.toLocaleLowerCase()))) &&
      (searchData?.PaymentMode === "" || (val?.PaymentMode && val?.PaymentMode?.toLocaleLowerCase().includes(searchData?.PaymentMode?.toLocaleLowerCase()))) &&
      (searchData?.BankName === "" || (val?.BankName && val?.BankName?.toLocaleLowerCase().includes(searchData?.BankName?.toLocaleLowerCase()))) &&
      (searchData?.ReferenceNo === "" || (val?.ReferenceNo && val?.ReferenceNo?.toString().toLocaleLowerCase().includes(searchData?.ReferenceNo))) &&
      (searchData?.transactionDateTime === "" || (val?.transactionDateTime && val?.transactionDateTime?.toLocaleLowerCase().includes(searchData?.transactionDateTime?.toLocaleLowerCase()))) &&
      (searchData?.depositDate === "" || (val?.depositDate && val?.depositDate?.toLocaleLowerCase().includes(searchData?.depositDate?.toLocaleLowerCase()))) &&
      (searchData?.CurrentBalance === "" || (val?.CurrentBalance && val?.CurrentBalance?.toString().toLocaleLowerCase().includes(searchData?.CurrentBalance))) &&
      (searchData?.RechargeAmount === "" || (val?.RechargeAmount && val?.RechargeAmount?.toString().toLocaleLowerCase().includes(searchData?.RechargeAmount))) &&
      (searchData?.ProcessingFees === "" || (val?.ProcessingFees && val?.ProcessingFees?.toString().toLocaleLowerCase().includes(searchData?.ProcessingFees))) &&
      (searchData?.AmountPaid === "" || (val?.AmountPaid && val?.AmountPaid?.toString().toLocaleLowerCase().includes(searchData?.AmountPaid))) &&
      (searchData?.ClosingBalance === "" || (val?.ClosingBalance && val?.ClosingBalance?.toString().toLocaleLowerCase().includes(searchData?.ClosingBalance))) &&
      (searchData?.RaisedBy === "" || (val?.RaisedBy && val?.RaisedBy?.toLocaleLowerCase().includes(searchData?.RaisedBy?.toLocaleLowerCase()))) &&
      (searchData?.RechargeStatus === "" || (val?.RechargeStatus && val?.RechargeStatus?.toLocaleLowerCase().includes(searchData?.RechargeStatus?.toLocaleLowerCase()))) &&
      (searchData?.RejectReason === "" || (val?.RejectReason && val?.RejectReason?.toLocaleLowerCase().includes(searchData?.RejectReason?.toLocaleLowerCase()))) &&
      (searchData?.AcceptOrRejectedBy === "" || (val?.AcceptOrRejectedBy && val?.AcceptOrRejectedBy?.toLocaleLowerCase().includes(searchData?.AcceptOrRejectedBy?.toLocaleLowerCase()))) &&
      (searchData?.AcceptedOrRejectedDateTime === "" || (val?.AcceptedOrRejectedDateTime && val?.AcceptedOrRejectedDateTime?.toLocaleLowerCase().includes(searchData?.AcceptedOrRejectedDateTime?.toLocaleLowerCase())))
    );
    setTableData(fiterData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);
  const handleSearchData = (event, field) => {
    let value = event.target.value.toString(); // Convert value to string
    setSearchData({ ...searchData, [field]: value });
  }

  useEffect(() => {
    const obj = {
      intCompanyID,
      intBranchID,
    }
    PartyRechargesListAllRequest(obj)
    GetRechargePaymentModesListAll()
    setRefresh(false)
  }, [refresh])
  useEffect(() => {
    const partyCity = resPartyCity.flatMap((party) => {
      const cityIds = party.CityID.split("~");
      const cityNames = party.PartyCitiesNames.split("~");
      return cityIds.map((id, index) => ({
        PartyID: party.PartyID,
        Party: party.Party,
        CityID: id,
        CityName: cityNames[index] || "",
      }));
    });
    setUpdatedRes(partyCity)
  }, [resPartyCity])
  useEffect(() => {
    const cities = updatedRes?.map(record => ({
      CityID: record.CityID,
      CityName: record.CityName,
    }));
    const cityList = removeDuplicatesFromArray(cities, 'CityID')
    const partyList = removeDuplicatesFromArray(updatedRes, 'PartyID')
    setSourceCityList([{ CityName: 'All', CityID: 0 }, ...cityList])
    setSourceBranchList([{ Party: 'All', PartyID: 0 }, ...partyList])
  }, [updatedRes])
  useEffect(() => {
    const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
    if (loginCity?.length > 0) {
      setSelSourceCity(loginCity[0])
    } else {
      setSelSourceCity(sourceCityList[0])
    }
  }, [sourceCityList])

  useEffect(() => {
    setSelSourceBranch(sourceBranchList[0])
  }, [sourceBranchList])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intPartyID: 0,
        intCompanyID: loginData.intCompanyID,
        strPartyName: "",
        strContactPerson: "",
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: 0
      }
      PostRequest(urls.getPartyList, obj).then((res) => {
        if (res.status === 'Success') {
          setResPartyCity(res?.Data)
        }
      })
    }
  }, [loginData])
  const HeaderData = [
    {
      company: loginData?.strCompanyName,
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
      toDate: moment(toDate).format('YYYY-MM-DD'),
      city: selSourceCity?.CityName,
      branch: selSourceBranch?.Party,
    },
  ]
  const sendOTPRequest = (PartyID) => {
    const partyIDIdToUse = PartyID || branchID;
    const obj = {
      Companyid: loginData?.intCompanyID,
      BranchID: 0,
      OTPType: 'PartyRecharge',
      PartyID: partyIDIdToUse,
      UserID: loginData?.intUserID,
      OTPDetails: '',
    }
    branchRechargeOTP(obj).then((res) => {
      if (res?.Status == true) {
        setOTP(res.OTP)
        // setOtpModal(true)
        updateModal(true, 'partyRechargeHistoryModel')
      } else {
        setOTP("")
        updateAlertError({ show: true, msg: res.ErrMessage })
      }
    }).catch((err) => {
      updateAlertError({ show: true, msg: err })
      console.log("Error:", err)
    })
  }
  const handleAccept = (item) => {
    let CompanyID, PartyID, RechargeID, Party;
    if (getCargoSettingData[0].IsRechargeApprovalOTP === 0) {
      ({ CompanyID, PartyID, RechargeID, Party } = item);
    } else {
      ({ CompanyID, PartyID, RechargeID, Party } = handleAcceptData);
    }

    const obj = {
      intCompanyID: CompanyID,
      intPartyID: PartyID,
      intRechargeID: RechargeID,
      intUserID: loginData.intUserID
    }
    PartyRechargesAccept(obj, () => { }, setMsg, setIsSuccessPop, Party)
  }
  const handleReject = () => {
    const { CompanyID, PartyID, RechargeID, Party } = handleAcceptData
    const obj = {
      intCompanyID: CompanyID,
      intPartyID: PartyID,
      intRechargeID: RechargeID,
      intUserID: loginData.intUserID
    }
    PartyRechargesReject(obj, () => { }, setMsg, setIsSuccessReject, Party)
  }
  const clickElement = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
  }
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const handleLoadButton = () => {
    // setShowTable(false)
    // setIsPdfLoading(false)
    // if (selVehicle === '' || selVehicle === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Vehicle No', nextId: 'loadbtn' })
    // } else if (selInclGSTComm === '' || selInclGSTComm === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Incl. GST on Comm', nextId: 'Incl_GST_Comm' })
    // } else if (selOfflineBooking === '' || selOfflineBooking === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Offline Booking', nextId: 'Offline_Booking' })
    // } else if (selToPayHamali === '' || selToPayHamali === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select To Pay Hamali', nextId: 'To_Pay_Hamali' })
    // } else {
    const body = {
      FromDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      CompanyID: loginData?.intCompanyID,
      PartyID: selSourceBranch?.PartyID,
    }
    getPartyRechargeListData(body).then((res) => {
      updateLoader(false)
      if (res.status === 'Success') {
        const data = res?.Data?.Table?.map((val, index) => ({ ...val, SN: index + 1, transactionDateTime: moment(val?.TransactionDate).format('DD-MMM-YYYY HH:mm'), AcceptedOrRejectedDateTime: val?.AcceptOrRejectedDate ? moment(val?.AcceptOrRejectedDate).format('DD-MMM-YYYY HH:mm') : '' }));
        setTableData(data || [])
        setReportData(data || [])
        setTotalNoOfRows(2)
        // setShowTable(true)
      } else {
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'loadbtn' })
        // setShowTable(false)
      }
    })
    // }

  }
  const InsideRowContent = ({ item, index, fontVal }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        <>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.SN}</TableCell>
          {/* <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left",whiteSpace:'nowrap', overflow: 'hidden',textOverflow: 'ellipsis',fontSize: fontVal }}>{item.CompanyID} </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left",whiteSpace:'nowrap', overflow: 'hidden',textOverflow: 'ellipsis',fontSize: fontVal }}>{item.CompanyName} </TableCell> */}
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.PartyCity} </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.PartyID}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.Party}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.PaymentMode}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.BankName}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.ReferenceNo}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.transactionDateTime}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.depositDate}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "right", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.CurrentBalance}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "right", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.RechargeAmount}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "right", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.ProcessingFees}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "right", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.AmountPaid}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.ClosingBalance}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.RaisedBy}</TableCell>
          <TableCell
            className="reportTD"
            colSpan={1}
            style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal, color: '#1f1f1f', fontWeight: '500' }}
            title={item.RechargeStatus}
          >
            <span
              className="status"
              style={{
                backgroundColor: item.RechargeStatus === 'Accepted' || item.RechargeStatus === 'Auto Accepted' ? '#5fcf23' : item.RechargeStatus === 'Rejected' ? '#F05924' : '#fff2e2',
                padding: '5px 10px 5px 10px',
                borderRadius: '12px',
                whiteSpace: 'nowrap',
              }}
            >
              {item.RechargeStatus}
            </span>
          </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.RejectReason}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.AcceptOrRejectedBy}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal }}>{item?.AcceptedOrRejectedDateTime}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ minWidth: '150px', textAlign: "left", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: fontVal, }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Button variant="contained" id="RechargeBtn" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px", background: loginData.intCompanyID === STA_COMPANY_ID && 'green', marginRight: '5px', width: '50px', fontSize: fontVal }} className="btn btn-primary"
                // onClick={() => {loginData?.intCompanyID===406?handleAccept():sendOTPRequest(item.BranchID); handleAccept(item.CompanyID, item.PartyID, item.RechargeID,item?.Party) }}
                onClick={() => { getCargoSettingData[0].IsRechargeApprovalOTP === 0 ? handleAccept(item) : sendOTPRequest(item.PartyID); setBranchID(item.PartyID); setHandleAcceptData(item); setType(0) }}
                disabled={["Accepted", "Auto Accepted", "Rejected"].includes(item.RechargeStatus)}
              // onKeyDown={(e) => {
              //   navigation1(e, 'select_Payment_Mode', 'CANCEL')
              // }}
              >
                ACCEPT
              </Button>
              <Button id={"CANCEL"} variant="outlined" sx={{ width: '50px', border: '1px solid #fe5200', background: loginData.intCompanyID === STA_COMPANY_ID && 'red', color: loginData.intCompanyID === STA_COMPANY_ID ? 'white !important' : '#fe5200', fontSize: fontVal }} className="receiveitembtn"
                // onClick={() => { handleReject(item.CompanyID, item.PartyID, item.RechargeID,item?.Party) }}
                onClick={() => { setShowModel(true); setBranchID(item.PartyID); setHandleAcceptData(item); setType(1) }}
                disabled={["Accepted", "Auto Accepted", "Rejected"].includes(item.RechargeStatus)}
              // onKeyDown={(e) => {
              //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
              // }}
              >
                REJECT
              </Button>
            </div>
          </TableCell>
        </>
      </TableRow>
    )
  }
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const headerColoumns = loginData.intCompanyID === STA_COMPANY_ID ? partyHistoryColForSTA : partyHistoryCol
    const pdfColumns = headerColoumns.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = branchRechargeFilterCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'landscape', format: [1156, 1636], unit: 'px', compress: true, });
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Party Recharge History.pdf`,
      subject: 'Party Recharge History',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        1: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        2: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        3: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        4: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },

      },
      theme: 'grid',
      startY: 120,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(
        //   `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
        //   data.settings.margin.left,
        //   150
        // )
        // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: tableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        2: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        6: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        7: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        8: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        9: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        10: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        11: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        12: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        13: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        14: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        15: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        16: { halign: 'left', minCellWidth: 150, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        17: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        18: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        19: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      // didParseCell: (data) => {
      //     crdeitDrawCellDetail(data)
      // },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Party Recharge History', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        PdfFooter(data, loginData, totalPagesExp)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Party Recharge History ${new Date().getTime()}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', 'Party Recharge History.pdf')
        // focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', 'Party Recharge History.pdf')
        // focusElemnt('backBtn')
      }, 2000)
    }
  }
  const selectedCity = (val) => {
    setSelSourceCity(val)
    let result = updatedRes?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.PartyID === 0)
    setSourceBranchList([{ PartyID: 0, Party: 'All' }, ...result])
  }
  const handleClose = () => {
    setShowModel(false)
  }
  return (
    <>
      {
        !viewLimit ?
          <>
            {
              showTable ?
                <Grid container className='reportButton' sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
                  <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                      <DropDownOA
                        id={'selectCompany'}
                        label={'Select Company'}
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        // minWidth="10%"
                        width="100%"
                      />
                    </Item>
                  </Grid>
                  <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                      <Datepicker
                        label={`From Date`}
                        // name={'from_date'}
                        id={'FromDate'}
                        // value={fromDate}
                        dateChange={(date) => {
                          setFromDate(date)
                          // focusElemnt(id.toDate)
                        }}
                        width="100%"
                      // startDate={'2022-01-01'}
                      // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                      // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
                      />
                    </Item>
                  </Grid>
                  <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                      <Datepicker
                        label={'To Date'}
                        // name={'to_date'}
                        id={'toDate'}
                        // value={toDate}
                        dateChange={(date) => {
                          setToDate(date)
                          // focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
                        }}
                        width="100%"
                      // startDate={'2022-01-01'}
                      // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                      // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                      />
                    </Item>
                  </Grid>
                  <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                      <DropDownOA
                        id={'partyCity'}
                        label={'Party City'}
                        data={sourceCityList}
                        defaultvalue={selSourceCity?.CityName}
                        idKey={`CityID`}
                        dataKey={`CityName`}
                        onSelect={(val) => {
                          selectedCity(val)
                        }}
                        isObjArr={true}
                        searchPlaceholder={`Search By Party City`}
                        width="100%"
                      // nextId={id.srcBranch}
                      // prevId={id.stateId}
                      // resetFlag={resetFlag || resetCity}
                      // disabled={disableBtn}
                      />
                    </Item>
                  </Grid>
                  <Grid item md={1.9}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                      <DropDownOA
                        id={'partyName'}
                        label={'Party Name'}
                        data={sourceBranchList}
                        defaultvalue={selSourceBranch?.Party || ''}
                        idKey={`PartyID`}
                        dataKey={`Party`}
                        onSelect={(val) => {
                          // setIsExpanded(false)
                          setSelSourceBranch(val)
                        }}
                        isObjArr={true}
                        searchPlaceholder={`Search By Party Name`}
                        width="100%"
                      // nextId={id.creditUsageSplitButton}
                      // prevId={id.srcCity}
                      // resetFlag={resetFlag || resetCity}
                      // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                      />
                    </Item>

                  </Grid>
                  <Grid item md={0.8}>
                    <Item sx={{ ...sx.itemsx }} className="">
                      <Button variant="contained" id="RechargeBtn" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                        onClick={handleLoadButton}
                      // onKeyDown={(e) => {
                      //   navigation1(e, 'select_Payment_Mode', 'CANCEL')
                      // }}
                      >
                        Load
                      </Button></Item>
                  </Grid>
                  <Grid item md={1.7}>

                    <Button id={"CANCEL"} variant="outlined" className="receiveitembtn"
                      onClick={() => setViewLimit(true)}
                      // onKeyDown={(e) => {
                      //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                      // }}
                      style={{ width: '100%' }}
                    >
                      VIEW LIMIT USAGES
                    </Button>
                  </Grid>
                  <Grid item md={0.8}>
                    <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                      onClick={() => printClick(false)}
                      // onKeyDown={(e) => {
                      //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                      // }}
                      style={{ width: '100%' }}
                    >
                      PRINT
                    </Button>
                  </Grid>
                  <Grid item md={0.8}>

                    <Box >
                      <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                        onClick={(e) => { clickElement('xls-buttons') }}
                        // onKeyDown={(e) => {
                        //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                        // }}
                        style={{ width: '100%' }}
                      >
                        EXCEL
                      </Button>
                      <ReactHtmlTableToExcel
                        id="xls-buttons"
                        table="tables"
                        filename={'Party Recharge History'}
                        sheet="sheet 1"
                        buttonText="EXPORT AS EXCEL"
                        className="excel-button"
                      />
                    </Box>
                  </Grid>
                </Grid> : <>
                  <Box>
                    <Button
                      style={{ border: '1px solid #fe5200', color: '#fe5200' }}
                      id="backBtn"
                      variant="outlined"
                      className="userWisereporttembtn"
                      onClick={() => (setShowTable(true))}
                    >
                      Back
                    </Button>
                  </Box>
                </>
            }
            {
              showTable ?
                <Box sx={{ padding: '12px 15px 4px 15px' }}>
                  <TableContainer className="scrollBlue" component={Paper} style={{ overflowX: 'auto', width: '100%', maxHeight: '45vh' }}>
                    <Table style={{ width: '100%' }} className="table1" size="small" aria-label="a dense table">
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '3' }}>
                        {
                          loginData.intCompanyID === STA_COMPANY_ID ?
                            <>
                              <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                                {partyHistoryColForSTA?.map((item, i) => (
                                  <TableCell key={i} style={{ width: item.minWidth, textAlign: item.align, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {item?.headerName}
                                  </TableCell>
                                ))}
                              </TableRow>
                              <TableRow>
                                {partyHistoryColForSTA?.map((col, index) => (
                                  <TableCell key={`FTH-${index}`} style={{ height: "36px" }}>
                                    {index !== 0 && index !== partyHistoryColForSTA?.length - 1 && <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                      <input
                                        id={`Contains-${index}`}
                                        className="field"
                                        name="cancelSearchInput"
                                        style={{ width: '100%', height: "24px" }}
                                        placeholder="Contains"
                                        autoComplete="off"
                                        value={searchData[col.field]}
                                        onChange={(e) => handleSearchData(e, col.field)}
                                      />
                                      <FilterAltIcon style={{ color: "#aaa" }} />
                                    </div>}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </>
                            :
                            <>
                              <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                                {partyHistoryCol?.map((item, i) => (
                                  <TableCell key={i} style={{ width: item.minWidth, textAlign: item.align, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {item?.headerName}
                                  </TableCell>
                                ))}
                              </TableRow>
                              <TableRow>
                                {partyHistoryCol?.map((col, index) => (
                                  <TableCell key={`FTH-${index}`} style={{ height: "36px" }}>
                                    {index !== 0 && index !== partyHistoryCol?.length - 1 && <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                      <input
                                        id={`Contains-${index}`}
                                        className="field"
                                        name="cancelSearchInput"
                                        style={{ width: '100%', height: "24px" }}
                                        placeholder="Contains"
                                        autoComplete="off"
                                        value={searchData[col.field]}
                                        onChange={(e) => handleSearchData(e, col.field)}
                                      />
                                      <FilterAltIcon style={{ color: "#aaa" }} />
                                    </div>}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </>
                        }

                      </TableHead>
                      {tableData?.length < 1 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={20}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginTop: '20px',
                                  marginBottom: '20px',
                                  color: 'red',
                                  fontSize: '14px',
                                }}
                              >
                                <span>No results found. Please refine your search parameters and search again.</span>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody className="filter-data-row" style={{ border: "none" }}>
                          {(
                            rowsPerPage > 0
                              ? tableData.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              ).map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                              : tableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                          )}
                        </TableBody>
                      )}
                    </Table>
                    <Table id="tables" style={{ width: '100%', display: 'none' }} className="table1" size="small" aria-label="a dense table">
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white`, display: 'none' }}>
                        <TableRow>
                          <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={10}>
                            <h3 style={{ paddingLeft: '17px' }}>Report For: Branch Recharge History -</h3>
                          </TableCell>
                          <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={9}>
                            <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={19}></TableCell>
                        </TableRow>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {branchRechargeFilterCol?.map((item, i) => (
                            <TableCell key={i} colSpan={item.colSpan} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line' }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                        {HeaderData.map((data, i) => (
                          <TableRow key={i} style={{ borderRadius: "10px" }}>
                            {branchRechargeFilterCol.map((col, j) => (
                              <TableCell
                                colSpan={col.colSpan}
                                key={j}
                                style={{
                                  textAlign: col.align,
                                  width: col.minWidth,
                                  color: "#444444",
                                  backgroundColor: "#F5F5F5",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {data[col.field]}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableHead>
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {partyHistoryCol?.map((item, i) => (
                            <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line' }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                      </ TableHead>
                      {tableData?.length < 1 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={20}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginTop: '20px',
                                  marginBottom: '20px',
                                  color: 'red',
                                  fontSize: '14px',
                                }}
                              >
                                <span>No results found. Please refine your search parameters and search again.</span>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody style={{ border: "none" }}>
                          {(
                            rowsPerPage > 0
                              ? tableData.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              ).map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                              ))
                              : tableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                              ))
                          )}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                  <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                    setPage(newPage);
                    //  handleLoadButton(newPage, rowsPerPage)
                  }} handleChangeRowsPerPage={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                    // handleLoadButton(0, parseInt(event.target.value, 10))
                  }} />
                </Box> : <>
                  {generatePDF ? <div style={{ textAlign: 'center' }} className={'generatePDF'}>Generating PDF....</div> : ''}
                  {load ? (
                    <object
                      id="branchRechargeHistory"
                      type="application/pdf"
                      width={'100%'}
                      height="440"
                      title="MTLPL -Cargo System - After Transfer Summary Report"
                      aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                      style={{ marginTop: '10px', textAlign: 'center' }}
                    ></object>
                  ) : (
                    ''
                  )}
                </>
            }
          </> : <PartyViewLimitUses setViewLimit={setViewLimit} />
      }
      <SuccessAndErrorModal isError={true} modalStyle={modalStyle} handleClose={() => { setIsSuccessReject(false); handleLoadButton(); updateModal(false, 'partyRechargeHistoryModel'); setOTP('') }} open={isSuccessReject} title={msg} />
      <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => { setIsSuccessPop(false); handleLoadButton(); updateModal(false, 'partyRechargeHistoryModel'); setOTP('') }} open={isSuccessPop} title={msg} />
      {showModal && 'partyRechargeHistoryModel' === modalType ? <OTPModal saveApi={type === 0 ? handleAccept : handleReject} OTP={OTP} isOpen={isSuccessPop} setIsOpen={setIsSuccessPop} sendOTPRequest={sendOTPRequest} /> : null}
      {
        showModel && <PartyRequestCancelRemark updateModal={handleClose} setShowModel={setShowModel} sendOTPRequest={sendOTPRequest} handleAcceptData={handleAcceptData} loginData={loginData} handleReject={handleReject} setTextAreaValue={setTextAreaValue} getCargoSettingData={getCargoSettingData} />
      }
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  PartyRechargesListAllRequest,
  updateModal,
  PartyRechargesReject,
  PartyRechargesAccept,
  GetRechargePaymentModesListAll,
  GetPartyRechargeEditRequest,
  getOwnChildBranches,
  getPartyRechargeListData,
  updateAlertError, GetCargoSettingData

}
export default connect(mapStateToProps, mapDispatchToProps)(PartyRechargeHistory)